/**
 * Locale/language constants derived from @config/i18n.
 * Single source of truth: i18n.ts i18nConfig. Add display names here when adding locales.
 */

import type { LocaleCode } from '@config/i18n';

/** Display names for locale selector. Add new locale here when adding to i18n.ts. */
export const LOCALE_DISPLAY_NAMES: Record<LocaleCode, string> = {
  'en-us': 'English (US)',
  'en-gb': 'English (UK)',
  'en-au': 'English (Australia)',
  'fr-fr': 'Français (French)',
  'de-de': 'Deutsch (German)',
  'es-es': 'Español (Spanish)',
  'it-it': 'Italiano (Italian)',
  'pt-pt': 'Português (Portuguese)',
  'he-il': 'Hebrew',
  'ro-ro': 'Română (Romanian)',
  'cs-cz': 'Čeština (Czech)',
  'fi-fi': 'Suomi (Finnish)',
  'nl-nl': 'Nederlands (Dutch)',
  'pl-pl': 'Polski (Polish)',
  'ar-xa': 'العربية (Arabic)',
};

/**
 * Returns display name for locale code.
 * @param localeCode - Locale code (e.g. en-us)
 * @returns Display name or locale code as fallback
 */
export const getLocaleDisplayName = (localeCode: LocaleCode): string =>
  LOCALE_DISPLAY_NAMES[localeCode] ?? localeCode;
